import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DataForCustomFormModel } from '@bo-client/activation-management/shared/models/actionWithMoreInfo.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommissioningRequestDtoModel } from '@bo-client/activation-management/shared/models/commissioningRequestDto';
import { CustomFormComponent } from '@bo-client/activation-management/custom-form.component';
import { SelectableStatus } from '@bo-client/shared/status/status.model';
import { StatusService } from '@bo-client/shared/status/status.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-cr-change-state',
  templateUrl: './cr-change-state.component.html',
  styleUrls: ['./cr-change-state.component.scss']
})
export class CrChangeStateComponent
  implements
    CustomFormComponent<
      CommissioningRequestDtoModel,
      {
        additionalData: string;
        comment: string;
      }
    >,
    OnInit
{
  @Input() data: DataForCustomFormModel<CommissioningRequestDtoModel>;
  @Output() onConfirm = new EventEmitter<{
    additionalData: string;
    comment: string;
  }>();

  public model: CommissioningRequestDtoModel;
  public currentForm: FormGroup;
  public comment = '';
  public statusOptions$: Observable<SelectableStatus[]>;

  constructor(private fb: FormBuilder, private statusService: StatusService) {}

  ngOnInit(): void {
    this.model = this.data.model;
    this.statusOptions$ = this.statusService.selectableWithCurrent$('commissioning', this.data.model.state);
    this.currentForm = this.fb.group({
      newState: [this.data.model.state, [Validators.required]],
      comment: [null, [Validators.required]]
    });
  }

  cancel() {
    this.onConfirm.emit(null);
  }

  confirm() {
    this.onConfirm.emit({
      additionalData: this.currentForm.get('newState').value,
      comment: this.currentForm.get('comment').value
    });
  }
}
